import React from "react";
import { Typography } from "@mui/material";

export default function JobDescription({ description }) {
  return (
    <Typography
      variant="body1"
      sx={{
        marginTop: { xs: 2, md: 6 },
        ul: {
          paddingLeft: 0,
          listStyle: "none",
        },
        textAlign: "justify",
        li: {
          marginBottom: 2,
        },
      }}
      gutterBottom
    >
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </Typography>
  );
}
